export const SUPPORT_STAGING_PROJECT = "studio-manager-phase2-staging";
export const SUPPORT_STAGING_ORIGINS = [
  `https://${SUPPORT_STAGING_PROJECT}.web.app`,
  `https://${SUPPORT_STAGING_PROJECT}.firebaseapp.com`,
];

export type SupportStagingState = "production" | "staging" | "blocked";

export function supportStagingState(env: { flag?: string; projectId?: string }, origin: string): SupportStagingState {
  const stagingProject = env.projectId === SUPPORT_STAGING_PROJECT;
  const stagingOrigin = SUPPORT_STAGING_ORIGINS.includes(origin);
  if (env.flag === "true") return stagingProject && stagingOrigin ? "staging" : "blocked";
  // A staging project or host without the explicit mode must never expose the full app.
  if (stagingProject || stagingOrigin || (env.flag !== undefined && env.flag !== "false" && env.flag !== "")) return "blocked";
  return "production";
}

export function isSupportStagingRoute(pathname: string): boolean {
  return pathname === "/login" || pathname === "/support/invite" || pathname === "/admin/apps/support" || pathname === "/staging/monitoring" ||
    pathname === "/org/support" || pathname.startsWith("/org/support/") ||
    pathname === "/admin/support" || pathname.startsWith("/admin/support/");
}

export function supportStagingHome(role: string | null): string {
  if (role === "PLATFORM_OWNER" || role === "PLATFORM_ADMIN") return "/admin/support/tickets";
  if (role === "ORG_OWNER" || role === "ORG_ADMIN" || role === "ORG_REQUESTER") return "/org/support";
  return "/login";
}
